import { HeartBank } from "../../../managers/HeartBank.ts";
import template from "./hb-about.mjs";
import { render } from "lit-html";

import { Modal } from "flowbite";
import type { ModalOptions, ModalInterface } from "flowbite";
import type { InstanceOptions } from "flowbite";

//import Strings from "../../../models/Strings.json";
//const strings: any = Strings;

export class HbAbout extends HTMLElement {
    private heartbank: HeartBank = new HeartBank();
    private modal: ModalInterface;

    private scan: HTMLElement;
    private switch: HTMLButtonElement;
    private photo: HTMLButtonElement;
    private audio: HTMLButtonElement;
    private film: HTMLButtonElement;
    private input: HTMLInputElement;
    private label: HTMLSpanElement;
    private message: HTMLElement;

    constructor() {
        super();
        render(template(null), this);

        this.scan = this.querySelector("#hb-about")!;
        this.switch = this.querySelector("#hb-about-switch")!;
        this.photo = this.querySelector("#hb-about-photo")!;
        this.audio = this.querySelector("#hb-about-audio")!;
        this.film = this.querySelector("#hb-about-film")!;
        this.input = this.querySelector("#hb-about-storage-input")!;
        this.label = this.querySelector("#hb-about-storage-label")!;
        this.message = this.querySelector("#hb-about-message")!;

        const modalOptions: ModalOptions = {
            placement: "center",
            backdrop: "dynamic",
            backdropClasses:
                "bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-40",
            closable: true,
            onHide: () => {
                //window.location.hash = "#";
            },
            onShow: () => {
                //console.log("modal is shown");
            },
            onToggle: () => {
                //console.log("modal has been toggled");
            }
        };

        // instance options object
        const instanceOptions: InstanceOptions = {
            id: "hb-about",
            override: true
        };

        this.modal = new Modal(this.scan, modalOptions, instanceOptions);
    }

    connectedCallback() {}

    show(page: string) {
        this.modal.show();
    }

    hide() {
        this.modal.hide();
    }
}
